// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set',
      targetId: string | Date,
      config?: any
    ) => void;
    dataLayer: any[];
  }
}

// Replace with your actual Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = 'G-RBTHK9STN4'; // Your actual GA4 Measurement ID

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
      page_title: title || document.title,
    });
  }
};

// Track custom events
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user interactions
export const trackUserInteraction = (action: string, element: string) => {
  trackEvent(action, 'User Interaction', element);
};

// Track form submissions
export const trackFormSubmission = (formName: string) => {
  trackEvent('form_submit', 'Form', formName);
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('click', 'Button', `${buttonName} - ${location}`);
};

// Track profile views
export const trackProfileView = (profileId: string) => {
  trackEvent('view_profile', 'Profile', profileId);
};

// Track search actions
export const trackSearch = (searchTerm: string) => {
  trackEvent('search', 'Search', searchTerm);
};

// Track login/registration
export const trackAuth = (action: 'login' | 'register') => {
  trackEvent(action, 'Authentication');
};

// Track errors
export const trackError = (errorMessage: string, location: string) => {
  trackEvent('error', 'Error', `${location}: ${errorMessage}`);
};